import { Button } from "@repo/ui"
import { ComponentProps, PropsWithChildren } from "react"
import { Link } from "react-router"
import { CaretLeft } from "@phosphor-icons/react"
import { cn } from "@/lib/utils"

export const BackToPrevPageLink = ({
  children,
  to,
  className,
}: PropsWithChildren<
  Pick<ComponentProps<typeof Link>, "to" | "className">
>) => (
  <Button variant={`link`} asChild>
    <Link
      to={to}
      className={cn(
        `flex items-center gap-2 px-3 py-2.5 -translate-x-[8px]`,
        className
      )}
    >
      <CaretLeft size={20} format={`outline`} weight={`light`} />
      <span>{children}</span>
    </Link>
  </Button>
)
